<template>
	<div class="animated fadeIn">

		<div class="row mb10">
			<div class="col-xs-12 clearfix">

				<div class="pull-left f24">
					<i class="fa fa-fire text-success"></i>
					<span>教学团队列表</span>
				</div>
				<div class="pull-right">
					<button class="btn btn-primary" @click.stop.prevent="$router.push('/cgd/by/person/create')">
						<i class="fa fa-send"></i>
						<span>创建教学团队</span>
					</button>
				</div>
			</div>
		</div>

		<div class="row">

			<div class="col-xs-12">
				<NbFilter :pager="pager" :callback="search"></NbFilter>
			</div>

			<div class="col-xs-12">
				<div v-for="person in pager.persons" class="bg-white p10 mt10 border-radius-4">

					<div class="row">

						<div class="col-sm-12 cursor" @click.stop.prevent="$router.push('/cgd/by/person/detail/'+person.id)">
							<div class="media">
								<div class="pull-left">
									<img class="img-rounded w120" v-if="person.image && person.image.url" :src="person.image.url">
								</div>
								<div class="pull-right action-buttons mt2">
									<a title="移到最前" @click.stop.prevent="top(person)">
										<i class="fa fa-arrow-up text-primary f20"></i>
									</a>
									<a title="编辑" @click.stop.prevent="$router.push('/cgd/by/person/edit/'+person.id)">
										<i class="fa fa-pencil text-info f20"></i>
									</a>
									<a href="javascript:void(0)" title="删除" @click.stop.prevent="confirmDel(person)">
										<i class="fa fa-trash text-danger f20"></i>
									</a>
								</div>
								<div class="media-body">
									<div>
										<span class=" f18 black">{{person.name}}</span>
									</div>
									<div class="mv5" v-if="person.title">
										头衔：{{person.title}}
									</div>
									<div class="mv5" v-if="person.phone">
										电话：{{person.phone}}
									</div>
									<div class="mv5" v-if="person.office">
										办公地点：{{person.office}}
									</div>
									<div class="mv5" v-if="person.email">
										邮件：{{person.email}}
									</div>
									<div>
										<span class="mr10">#{{person.id}}</span>
										<span class="mr10">创建于:{{person.createTime | simpleDate}}</span>
									</div>

								</div>
							</div>
						</div>

					</div>


				</div>

			</div>


			<div class="col-xs-12 mt20">
				<NbPager :pager="pager" :callback="refresh"></NbPager>
			</div>

		</div>


	</div>

</template>
<script>

	import NbFilter from '../../../common/widget/filter/NbFilter.vue'
	import NbPager from '../../../common/widget/NbPager.vue'
	import {MessageBox, Notification} from 'element-ui'
	import Pager from  "../../../common/model/base/Pager"
	import Person from  "../../../common/model/person/Person"

	export default {

		data () {
			return {
				pager: new Pager(Person)
			}
		},
		components: {
			NbFilter,
			NbPager
		},
		computed: {},
		watch: {},
		methods: {
			top(person){
				let that = this;
				person.httpTop(function () {
					that.refresh();
				});
			},
			search(){
				this.pager.page = 0;
				this.refresh()
			},
			refresh(){
				this.pager.httpFastPage();
			},
			confirmDel(person){
				let that = this;
				MessageBox.confirm('此操作将永久删除该友情列表, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.fetchDel(person);
					},
					function () {

					}
				);
			},
			fetchDel(person){

				let that = this;

				person.httpDel(function () {
					Notification.success({
						message: '成功删除友情列表!'
					});
					that.refresh();
				});
			}
		},
		mounted(){
			this.pager.enableHistory();
			this.refresh();
		}
	}

</script>



// WEBPACK FOOTER //
// List.vue?64a6984a